import { supabase } from '../client'

export async function getArtistsPage(limit = 1000) {
  const { data, error } = await supabase
    .from('artists')
    .select('*')
    .order('createdAt', { ascending: false })
    .limit(limit + 1)

  return { data, error }
}
